<div
  [ngClass]="position()"
  class="label"
  uiTooltip
  [tooltipText]="extended() ? '' : ('SHARED.UNDER_DEVELOPMENT' | transloco)"
  [tooltipPosition]="tooltipPosition()"
  [tooltipArrow]="false"
>
  <div class="label-content">
    <ui-inline-svg class="label-content-icon" name="editor/code" />
    @if (extended()) {
      <div class="label-content-text">{{ 'SHARED.UNDER_DEVELOPMENT' | transloco }}</div>
    }
  </div>
</div>
